import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { setAppLocale } from '@/i18n';
import { isAppLocale, type AppLocale } from '@/i18n/types';

export function useAppLocale() {
  const { i18n } = useTranslation();
  const locale: AppLocale = isAppLocale(i18n.language) ? i18n.language : 'en';
  const isRtl = locale === 'ar';

  const changeLocale = useCallback(
    async (next: AppLocale) => {
      if (next === locale) return;
      await setAppLocale(next);
    },
    [locale],
  );

  return { locale, isRtl, changeLocale };
}
